import React from 'react';
import { Flex, Box, Heading } from '@chakra-ui/react';
import Logo from 'assets/logo.png';

interface NavbarProps {
  title: string;
}

const Navbar: React.FC<NavbarProps> = ({ title }) => {
  return (
    <Flex
      width="100%"
      justifyContent="center"
      alignItems="center"
      bgColor="#10242A"
      height="100px"
      p="20px 0"
    >
      <Box width="12%" height="85px" position="absolute" left="15px">
        <img src={Logo} alt="Logomarca ocidental grupo" />
      </Box>
      <Box
        height="100%"
        display="flex"
        alignItems="end"
        justifyContent="flex-start"
      >
        <Heading color="#fff">{title}</Heading>
      </Box>
    </Flex>
  );
};

export default Navbar;
